import { memo, useEffect, useRef } from 'react';
import { trpc } from 'root/src/client/v2/trpc/trpc';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { useIsCreator } from 'root/src/client/v2/auth/hooks/useIsCreator';
import { useIsAuthenticated } from 'root/src/client/v2/auth/hooks/useIsAuthenticated';
import { SUGGESTED_DARE_PROMPT_CONFIG } from 'root/src/shared/constants/suggestedDarePrompt';
import { useSuggestedDarePromptCadence, } from 'root/src/client/v2/creator/components/SuggestedDareModal/useSuggestedDarePromptCadence';
import { SuggestedDareModal, } from 'root/src/client/v2/creator/components/SuggestedDareModal/SuggestedDareModal';
import toast from 'react-hot-toast';
export const SuggestedDareModalLauncher = memo(() => {
    const isAuthenticated = useIsAuthenticated();
    const { isCreator } = useIsCreator();
    const modal = useModal();
    const cadence = useSuggestedDarePromptCadence({ enabled: isAuthenticated && isCreator });
    const hasShownThisMount = useRef(false);
    const shouldFetch = SUGGESTED_DARE_PROMPT_CONFIG.enabled
        && isAuthenticated
        && isCreator
        && cadence.isReady
        && cadence.isDue;
    const query = trpc.drops.getSuggestedDropForCreator.useQuery(undefined, {
        enabled: shouldFetch,
        staleTime: 5 * 60 * 1000,
    });
    useEffect(() => {
        if (hasShownThisMount.current) {
            return undefined;
        }
        if (!query.data) {
            return undefined;
        }
        const suggestion = query.data;
        if (cadence.isDropCurrentlyDismissed(suggestion.drop.id)) {
            return undefined;
        }
        const delayMs = Math.max(0, cadence.activeConfig.showDelaySeconds) * 1000;
        const timerId = window.setTimeout(() => {
            if (hasShownThisMount.current) {
                return;
            }
            hasShownThisMount.current = true;
            const context = {
                dropId: suggestion.drop.id,
                dareId: suggestion.dare.id,
                similarityScore: suggestion.similarityScore,
            };
            cadence.recordShown(context);
            modal.show(<SuggestedDareModal suggestion={suggestion} onAccepted={() => {
                    cadence.recordAccepted({
                        dropId: suggestion.drop.id,
                        dareId: suggestion.dare.id,
                        similarityScore: suggestion.similarityScore,
                    });
                    toast.success('Dare accepted!');
                }} onSnooze={() => {
                    cadence.recordSnooze(context);
                }} onDismiss={(dropId) => {
                    cadence.recordDismiss(dropId, {
                        dareId: suggestion.dare.id,
                        similarityScore: suggestion.similarityScore,
                    });
                }}/>);
        }, delayMs);
        return () => {
            window.clearTimeout(timerId);
        };
    }, [query.data, modal, cadence]);
    return null;
});
